import { Habit } from '@griply/types';

// Frozen habits are the backend's over-limit lock; counting them would block a user for good. Trashed ones are gone.
const countsTowardLimit = ({
  excludedFromLimits,
  deletedAt,
  completedAt,
  archivedAt,
  frozenAt,
}: Habit): boolean =>
  !excludedFromLimits && !deletedAt && !completedAt && !archivedAt && !frozenAt;

export const countHabitsTowardLimit = (habits: Habit[]): number =>
  habits.filter(countsTowardLimit).length;
